<template>
  <div id="equip-statistic-pie" style="height: 400px;width: 100%;" />
</template>

<script>
import { debounce } from "@/utils/common";

export default {
  name: "EquipStatisticPie",

  props: {
    stat: {
      type: Object,
      default: {},
    },
  },

  data() {
    return {
      loading: false,
      chart: null,
      chartOption: {
        title: {
          show: false,
        },
        legend: {
          orient: "horizontal",
          bottom: "20%",
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} : {c} ({d}%)",
        },
        series: [
          {
            type: "pie",
            label: {
              show: true,
              position: "outside",
              formatter: "{b} {c}",
            },
            radius: ["35%", "50%"],
            center: ["50%", "35%"],
            data: [
              {
                value: 0,
                name: "服务正常",
                itemStyle: {
                  color: "#07c160",
                },
              },
              {
                value: 0,
                name: "已到期",
                itemStyle: {
                  color: "#f0ad4e",
                },
              },
              {
                value: 0,
                name: "已注销",
                itemStyle: {
                  color: "#e64340",
                },
              },
            ],
          },
        ],
      },
    };
  },

  mounted() {
    this.initChart();
    this.__resizeHandler = debounce(() => {
      if (this.chart) {
        this.chart.resize();
      }
    }, 100);
    window.addEventListener("resize", this.__resizeHandler);
  },

  watch: {
    stat(val1,val2) {
      this.stat = val1
      this.initChart()
    }
  },

  created() {},

  methods: {
    initChart() {
      this.chart = this.$echarts.init(this.$el, "teenager");
      this.chartOption.series[0].data[0].value = this.stat.normal_count;
      this.chartOption.series[0].data[1].value = this.stat.expire_count;
      this.chartOption.series[0].data[2].value = this.stat.recycle_count;
      this.chart.setOption(this.chartOption);
    },
  },
};
</script>
